import React, { useContext, useEffect, useState } from "react";
import { Outlet, useParams, useNavigate } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/sidebar/Sidebar";
import Main from "../components/Main";
import NavbarSimple from "../components/navbar/NavbarSimple";
import Content from "../components/Content";
import Settings from "../components/Settings";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ReactPlayer from "react-player/lazy";

import docItems from "../components/sidebar/docItems";
import dashboardItems from "../components/sidebar/dashboardItems";

import { VideosContext } from "../contexts/VideosContext";
import useSidebar from "../hooks/useSidebar";
import { DefaultPlayer as Video } from "react-html5video";
import {
  parseDate,
  toHoursAndMinutesVideoPlayPage,
  convertDatetoTime,
} from "../utils/dateandtime";
import { fullOrientation } from "../utils/orientation";
import "react-html5video/dist/styles.css";
import "./styles.css";
import VideoPlayModal from "../components/VideoPlayModal";
import axios from "axios";
import { tenantOrigin } from "../utils/apis";
import { unescape } from "../utils/token";

// interface VideoPlayModalProps {
//   videoURL: string;
//   // closeModal: () => void;
//   isModalOpen: boolean;
//   setIsModalOpen: Function;
// }

const getClassname = (sensitivity: string): string | undefined => {
  if (sensitivity === "public") return "badge bg-info";
  if (sensitivity === "sharing") return "badge bg-success";
  if (sensitivity === "internal") return "badge bg-warning text-dark";
  return;
};

const VideoPlay: React.FC = () => {
  const { isOpen } = useSidebar();
  const { videos, setVideos } = useContext(VideosContext);
  const [otp, setOtp] = useState("");
  const [finalURL, setFinalURL] = useState("");

  const navigate = useNavigate();
  console.log("video-videoplaypage", videos);
  console.log("setVideos-play", setVideos);
  const oauth2Token2ndString = localStorage.getItem("oauth2Token2nd");
  let oauth2Token2nd: { sls: string; police: string; ta: string; uts: string } =
    { sls: "", police: "", uts: "", ta: "" };

  if (oauth2Token2ndString) {
    oauth2Token2nd = JSON.parse(oauth2Token2ndString);
  }

  console.log("oauth2Token2nd22", oauth2Token2nd);

  const videolist0 = localStorage.getItem("videolist");
  let videolist;
  if (videolist0) {
    videolist = JSON.parse(videolist0);
  }

  let { id } = useParams();
  console.log("videoid", id);
  console.log("videolist", videolist);

  interface videoType {
    videoURL: string;
    _id: string;
    sensitivity: string;
    date: string;
    duration: number;
    provider: string;
    postcode: string;
    locality: string;
    thumbnail: string[];
    name: string;
    camera: string;
    keywords: string[];
    location: {};
    orientation: string;
    __v: number;
  }

  let thisVideo: videoType = {
    videoURL: "",
    _id: "",
    sensitivity: "",
    date: "",
    duration: 0,
    provider: "",
    postcode: "",
    locality: "",
    thumbnail: [""],
    name: "",
    camera: "",
    keywords: [""],
    location: {},
    orientation: "",
    __v: 0,
  };

  if (id && videolist) {
    videolist.map((video: videoType) => {
      if (video._id === id) {
        thisVideo = video;
      }
      return "";
    });
  }
  console.log("thisVideo", thisVideo);

  const {
    videoURL,
    date,
    duration,
    locality,
    provider,
    sensitivity,
    name,
    thumbnail,
    postcode,
    orientation,
    _id,
  } = thisVideo;
  let organisation: string = "";
  const loginUser = localStorage.getItem("user");
  const loginUserObject = loginUser && JSON.parse(loginUser);
  if (loginUserObject) {
    organisation = loginUserObject.organisation;
  }
  interface LooseObject {
    [key: string]: any;
  }
  const is2ndAuth: LooseObject = {
    sls: undefined,
    police: undefined,
    uts: undefined,
    ta: undefined,
  };

  const get2ndAuthUrl = (provider: string) => {
    if (organisation && provider) {
      return `${tenantOrigin(provider)}/api/user/auth/login/${organisation}`;
    }
  };

  console.log("url", get2ndAuthUrl(provider));

  const authrizeBtnHandler = () => {
    if (sensitivity !== "public") {
      if (provider !== undefined && !is2ndAuth[provider]) {
        // Open the provider-side login; the popup posts the token back to this
        // tab (message listener below). Don't navigate/reload here — that
        // killed the page before the popup could deliver the token.
        window.open(
          `${get2ndAuthUrl(provider)}`,
          "_blank",
          "height=500, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no" // <- This is what makes it open in a new window.
        );
      }
    }
  };

  // Capture the 2nd-factor token posted back by the provider-login popup
  // (this page is opened in its own tab, so the Dashboard's listener can't).
  useEffect(() => {
    const messageEvent = (e: any) => {
      if (typeof e.data !== "string") return;
      let org = "";
      try {
        org = new URL(e.origin).hostname.split(".")[0];
      } catch {
        return;
      }
      if (!org || org === "dsp") return;
      try {
        const processed = JSON.parse(unescape(e.data));
        const stored = localStorage.getItem("oauth2Token2nd");
        const tokens = stored
          ? JSON.parse(stored)
          : { sls: "", police: "", uts: "", ta: "" };
        tokens[org] = processed.token;
        localStorage.setItem("oauth2Token2nd", JSON.stringify(tokens));
        // Re-run the page with the token in place (fetches the OTP, plays).
        window.location.reload();
      } catch (err) {
        console.log("2nd-auth message parse failed", err);
      }
    };
    window.addEventListener("message", messageEvent, false);
    return () => window.removeEventListener("message", messageEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let otpHeader: {} = {};
  let showVideoNeedAuthReqBtn: boolean = false;
  console.log(oauth2Token2nd, "oauth2Token2nd1");
  if (sensitivity === "public") {
    showVideoNeedAuthReqBtn = false;
  } else if (sensitivity !== "public") {
    // if (!oauth2Token2nd[provider] || oauth2Token2nd[provider] === "") {
    //   showVideoNeedAuthReqBtn = true;
    // }
    if (oauth2Token2nd) {
      if (provider === "sls") {
        if (oauth2Token2nd.sls === "") {
          showVideoNeedAuthReqBtn = true;
        } else {
          otpHeader = { Authorization: `Bearer ${oauth2Token2nd.sls}` };
        }
      }
      if (provider === "uts") {
        if (oauth2Token2nd.uts === "") {
          showVideoNeedAuthReqBtn = true;
        } else {
          otpHeader = { Authorization: `Bearer ${oauth2Token2nd.uts}` };
        }
      }
      if (provider === "police") {
        if (oauth2Token2nd.police === "") {
          showVideoNeedAuthReqBtn = true;
        } else {
          otpHeader = { Authorization: `Bearer ${oauth2Token2nd.police}` };
        }
      }
      if (provider === "ta") {
        if (oauth2Token2nd.ta === "") {
          showVideoNeedAuthReqBtn = true;
        } else {
          otpHeader = { Authorization: `Bearer ${oauth2Token2nd.ta}` };
        }
      }
    }
  }
  console.log("otpheader", otpHeader);
  console.log(oauth2Token2nd, "oauth2Token2nd2");
  console.log("showVideoNeedAuthReqBtn", showVideoNeedAuthReqBtn);
  const getOtpUrl = (provider: string) => {
    return provider ? `${tenantOrigin(provider)}/api/user/otp` : "";
  };
  console.log("getOtpUrl", getOtpUrl(provider));

  const getOTPFunction = async () => {
    await axios.get(getOtpUrl(provider), { headers: otpHeader }).then(
      (res) => {
        console.log("otpdata", res.data);
        if (res.data.otp) {
          setOtp(res.data.otp);
        }
      },
      (error) => {
        console.log(error);
        // The stored 2nd-factor token no longer works (e.g. db reset) — drop
        // it so the "Apply Authorisation" button comes back instead of
        // failing silently forever.
        if (error?.response?.status === 401) {
          const stored = localStorage.getItem("oauth2Token2nd");
          if (stored) {
            const tokens = JSON.parse(stored);
            if (tokens[provider]) {
              tokens[provider] = "";
              localStorage.setItem("oauth2Token2nd", JSON.stringify(tokens));
              window.location.reload();
            }
          }
        }
      }
    );
  };

  const OTPsInitialValue = {
    sls: "",
    police: "",
    uts: "",
    ta: "",
  };
  let OTPs = OTPsInitialValue;
  const OTPsFromStorage = localStorage.getItem("otp");
  const OTPsFromStorageOBJ = OTPsFromStorage && JSON.parse(OTPsFromStorage);
  if (OTPsFromStorageOBJ) {
    OTPs = OTPsFromStorageOBJ;
  }
  useEffect(() => {
    // Only ask the provider for an OTP once we hold its 2nd-factor token —
    // without one the request is a guaranteed 401.
    if ((otpHeader as any).Authorization) {
      getOTPFunction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otpHeader]);

  if (provider === "sls") {
    OTPs.sls = otp;
  }
  if (provider === "police") {
    OTPs.police = otp;
  }
  if (provider === "ta") {
    OTPs.ta = otp;
  }
  if (provider === "uts") {
    OTPs["uts"] = otp;
  }

  localStorage.setItem("otp", JSON.stringify(OTPs));

  let finalVideoUrl: string = "";
  console.log("otp", otp);
  if (sensitivity === "public") {
    finalVideoUrl = videoURL;
    // setFinalURL(finalVideoUrl);
  }
  if (sensitivity !== "public") {
    if (otp !== undefined && otp !== "") {
      finalVideoUrl = `${videoURL}&otp=${otp}`;
    }
    // setFinalURL(finalVideoUrl);
  }
  console.log("finalVideoUrl", finalVideoUrl);
  console.log("finalURL", finalURL);
  // const messageEvent2 = (e: any) => {
  //   console.log("second time oauth", e);
  //   let secondOauthData: string;
  //   if (typeof e.data === "string") {
  //     secondOauthData = e.data;
  //     let processedSecondOauthData = JSON.parse(unescape(secondOauthData));
  //     const bearerToken = processedSecondOauthData.token;
  //     const loginProfile = processedSecondOauthData.profile;
  //     document.cookie = `oauthToken=${bearerToken}`;
  //     localStorage.setItem("user2", JSON.stringify(loginProfile));
  //     localStorage.setItem("accessToken2", bearerToken);
  //   }
  // };

  // useEffect(() => {
  //   console.log("here in video play page get message");
  //   window.addEventListener("message", messageEvent2, false);
  //   return () => window.removeEventListener("message", messageEvent2);
  // }, []);

  return (
    <React.Fragment>
      <Wrapper>
        {false && <VideoPlayModal isModalOpen={true} />}
        <Sidebar items={dashboardItems} />
        <Main>
          <NavbarSimple />
          <Content>
            {/* <div className="modalwrapper"> */}
            {/* <div className="modalcontainer"> */}
            {/* <div className="cancelbtndiv">
              <CancelOutlinedIcon
                // onClick={() => setIsModalOpen(false)}
                sx={{
                  fontSize: "50px",
                  color: "white",
                }}
              />
            </div> */}
            <div className="player-wrapper">
              {finalVideoUrl && (
                <Video
                  autoPlay
                  // loop
                  // muted
                  controls={[
                    "PlayPause",
                    "Seek",
                    "Time",
                    "Volume",
                    "Fullscreen",
                  ]}
                  // poster="http://sourceposter.jpg"
                  // onCanPlayThrough={() => {
                  //   // Do stuff
                  // }}
                >
                  <source src={finalVideoUrl} />
                  {/* <track
                  label="English"
                  kind="subtitles"
                  srcLang="en"
                  // src="http://source.vtt"
                  default
                /> */}
                </Video>
              )}

              <div className="video-info-bar">
                <div className="video-info-top">
                  <h2 className="flex-item">{name.toUpperCase()}</h2>
                  <div
                    style={{ fontSize: "16px", padding: "8px" }}
                    className={`${getClassname(sensitivity)} marginx5 `}
                  >
                    {sensitivity}
                  </div>
                  {showVideoNeedAuthReqBtn && (
                    <div
                      style={{
                        fontSize: "16px",
                        padding: "8px",
                        cursor: "pointer",
                      }}
                      className="badge bg-danger text-yellow marginx5"
                      onClick={authrizeBtnHandler}
                    >
                      Apply Authorisation from {provider.toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="video-info-btm">
                  <span className="marginx5">
                    • Provider : {provider.toUpperCase()}
                  </span>
                  <span className="marginx5">
                    • Location : {locality} {postcode}
                  </span>
                  <span className="marginx5">
                    • Orentation: {fullOrientation(orientation)}
                  </span>
                </div>
                <div className="video-info-btm">
                  <span className="marginx5">
                    • Duration: {toHoursAndMinutesVideoPlayPage(duration)}
                  </span>
                  <span className="marginx5">
                    • Recording time : {parseDate(date)}{" "}
                    {convertDatetoTime(date)}
                  </span>
                </div>
              </div>
            </div>

            {/* </div> */}
            {/* </div> */}
            <Outlet />
          </Content>
        </Main>
      </Wrapper>
      <Settings />
    </React.Fragment>
  );
};

export default VideoPlay;
